<div class="physical-exposure-wrapper">
    <div class="title-column">
        <sergeant-title [title]="'Fysisk risiko'" (showMoreClicked)="goToPhysicalExposures()"></sergeant-title>
        <div class="physical-exposure-subtitle">{{ affectingExposures() }}</div>
    </div>
    <div class="physical-exposure-risk-score" (click)="openScoreInformation()" (close)="closeScoreInformation()" (clickOutside)="closeScoreInformation()">
        {{ physicalExposures()?.totalPhysicalRiskScore }}
        <ev_tooltip 
            [visible]="tooltipOpen" 
            [right]="-47" 
            [bottom]="40" 
            [arrow]="'none'" 
            [title]="'Risikoscore'" 
            [width]="380">
                <div class="score-popup">
                    <div class="score-dialog">
                        Total fysisk risikoscore for denne eiendommen er {{ physicalExposures()?.totalPhysicalRiskScore }} av 6, der 6 er høyest risiko. Total
                        fysisk risikoscore settes lik den høyeste risikoscoren for de underliggende fysisk risiko scenariene.
                    </div>
                </div>
        </ev_tooltip>
    </div>
</div>
